export default Object.freeze({
  onNodeClick: 'treeView.nodeClick',
  update: 'treeView.update',
});
